import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../../../assets/icons/copy.svg'


const _hoisted_1 = {
  key: 0,
  class: "wallet_summary"
}
const _hoisted_2 = { class: "tw-flex tw-gap-3" }
const _hoisted_3 = { class: "tw-w-1/2 tw-max-w-full tw-flex tw-gap-3 tw-flex-col" }
const _hoisted_4 = { class: "tw-flex tw-flex-col" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "tw-text-xs tw-tracking-[0.25px] tw-leading-[22px] tw-font-medium tw-text-[#0c0f4a]" }, " Beneficiary ", -1)
const _hoisted_6 = { class: "tw-flex tw-items-center tw-justify-between" }
const _hoisted_7 = { class: "tw-text-[21px] tw-text-normal tw-leading-[30px] tw-font-normal tw-text-[#0c0f4a] tw-w-[calc(100%_-_20px)] md:!tw-text-[12px] md:!tw-font-bold" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("button", { class: "tw-flex" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_9 = { class: "tw-flex tw-flex-col" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "tw-text-xs tw-tracking-[0.25px] tw-leading-[22px] tw-font-medium tw-text-[#0c0f4a]" }, " Sort Code ", -1)
const _hoisted_11 = { class: "tw-flex tw-items-center tw-justify-between" }
const _hoisted_12 = { class: "tw-text-[21px] tw-text-normal tw-leading-[30px] tw-font-normal tw-text-[#0c0f4a] md:!tw-text-[12px] md:!tw-font-bold" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("button", { class: "tw-flex" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_14 = { class: "tw-w-1/2 tw-max-w-full tw-flex tw-gap-3 tw-flex-col" }
const _hoisted_15 = { class: "tw-flex tw-flex-col" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "tw-text-xs tw-tracking-[0.25px] tw-leading-[22px] tw-font-medium tw-text-[#0c0f4a]" }, " Account number", -1)
const _hoisted_17 = { class: "tw-flex tw-items-center tw-justify-between" }
const _hoisted_18 = { class: "tw-text-[21px] tw-text-normal tw-leading-[30px] tw-font-normal tw-text-[#0c0f4a] md:!tw-text-[12px] md:!tw-font-bold" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("button", { class: "tw-flex" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_20 = { class: "tw-flex tw-flex-col" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "tw-text-xs tw-tracking-[0.25px] tw-leading-[22px] tw-font-medium tw-text-[#0c0f4a]" }, " Reference", -1)
const _hoisted_22 = { class: "tw-flex tw-items-center tw-justify-between" }
const _hoisted_23 = { class: "tw-text-[21px] tw-text-normal tw-leading-[30px] tw-font-normal tw-text-[#0c0f4a] md:!tw-text-[12px] md:!tw-font-bold" }
const _hoisted_24 = { class: "tw-flex" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { class: "amount_details" }
const _hoisted_28 = { class: "tw-text-xs tw-tracking-[0.25px] tw-leading-[22px] tw-font-medium tw-text-[#0C0F4A]" }
const _hoisted_29 = { class: "tw-text-xs tw-tracking-[0.25px] tw-leading-[22px] tw-font-bold tw-text-[#0C0F4A]" }
const _hoisted_30 = { class: "tw-flex tw-items-center tw-justify-between tw-my-2" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", { class: "tw-text-xs tw-tracking-[0.25px] tw-leading-[22px] tw-font-medium tw-text-[#0C0F4A]" }, " Subtotal ", -1)
const _hoisted_32 = { class: "tw-text-xs tw-tracking-[0.25px] tw-leading-[22px] tw-font-bold tw-text-[#0C0F4A]" }
const _hoisted_33 = { class: "tw-flex tw-items-center tw-justify-between tw-my-2" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", { class: "tw-text-xs tw-tracking-[0.25px] tw-leading-[22px] tw-font-medium tw-text-[#0C0F4A]" }, " vat ", -1)
const _hoisted_35 = { class: "tw-text-xs tw-tracking-[0.25px] tw-leading-[22px] tw-font-bold tw-text-[#0C0F4A]" }
const _hoisted_36 = { class: "tw-flex tw-items-center tw-justify-between tw-my-2" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("p", { class: "tw-text-lg tw-tracking-[0.25px] tw-leading-[22px] tw-font-medium tw-text-[#0C0F4A]" }, " Total ", -1)
const _hoisted_38 = { class: "tw-text-lg tw-tracking-[0.25px] tw-leading-[22px] tw-font-bold tw-text-[#0C0F4A]" }
const _hoisted_39 = { class: "confirm_wrapper tw-mt-8" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("p", { class: "tw-text-sm tw-tracking-[0.25px] tw-leading-[22px] tw-font-medium tw-text-[#0c0f4a80]" }, " Find Your Bank? ", -1)
const _hoisted_41 = {
  key: 0,
  class: "tw-mt-6 tw-text-[10px] tw-tracking-[0.25px] tw-leading-[18px] tw-font-medium tw-text-[#0c0f4a80] tw-text-center"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", { class: "tw-text-[#0c0f4a]" }, "Terms & conditions", -1)

import CommonDialog from "@/core/components/CommonDialog.vue";
import CommonLoader from "@/core/components/CommonLoader.vue";
import Button from "@/core/components/ui/general/Button.vue";
import { EscrowStatusEnum } from "@/core/enums/estimateEnum";
import { ProjectPhaseType } from "@/core/enums/ProjectsEnum";
import tradeEstimateService from "@/core/services/trade-estimate.service";
import CurrencyFilter from "@/filters/currency.filter";
import { onMounted, ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'PayEWalletModal',
  props: {
  selectedPhases: {
    type: Array,
  },
  subTotalAmount: {
    type: Number,
  },
  vatTotal: {
    type: Number,
  },
  projectId: {
    type: Number,
  },
},
  emits: ["on-close", "on-redirect-bank", "on-confirm"],
  setup(__props, { emit: __emit }) {

const emits = __emit;

const formValid = ref(false);
const props = __props;
const bankList = ref([]);

const phaseEstimateType = (phase: any) => {
  if (phase?.phaseType === ProjectPhaseType.MATERIAL) return "Materials";
  else return phase?.name;
};
const formattedCurrency = (value: any) => {
  return CurrencyFilter.formatToCurrency(value);
};
const selectedBank = ref(null);
const loading = ref(false);
const onClickBackButton = () => {
  emits("on-close");
};

const onSelectRedirectBank = () => {
  emits("on-redirect-bank");
};
const onConfirm = () => {
  emits("on-confirm");
};
const eWalletDetails = ref(null);
const copyToClipboard = (value: any) => {
  var tempTextarea = document.createElement("textarea");
  tempTextarea.value = value;

  document.body.appendChild(tempTextarea);

  tempTextarea.select();

  document.execCommand("copy");

  document.body.removeChild(tempTextarea);
};

onMounted(async () => {
  try {
    eWalletDetails.value = await tradeEstimateService.getEscrowEWalletDetails(
      props?.projectId
    );
    loading.value = true;
  } catch (error) {
    console.log("error", error);
  } finally {
    loading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_form = _resolveComponent("v-form")!
  const _directive_clipboard = _resolveDirective("clipboard")!

  return (_openBlock(), _createBlock(CommonDialog, {
    HeaderTittle: "Pay Money Into Your E-Wallet",
    width: "560px",
    onClickBackButton: onClickBackButton,
    className: ['escrow_pay_money_e-wallet']
  }, {
    body: _withCtx(() => [
      (!loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_form, {
              ref: "form",
              modelValue: formValid.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formValid).value = $event)),
              class: "tw-max-w-full tw-mt-6 tw-flex tw-flex-col tw-gap-6"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _hoisted_5,
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("span", _hoisted_7, _toDisplayString(eWalletDetails.value?.name), 1),
                        _hoisted_8
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("span", _hoisted_12, _toDisplayString(eWalletDetails.value?.sortCode), 1),
                        _hoisted_13
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("span", _hoisted_18, _toDisplayString(eWalletDetails.value?.accountNumber), 1),
                        _hoisted_19
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("span", _hoisted_23, _toDisplayString(eWalletDetails.value?.reference), 1),
                        _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_24, _hoisted_26)), [
                          [_directive_clipboard, eWalletDetails.value?.reference, "copy"]
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.selectedPhases, (phase) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: phase?.id,
                      class: "tw-flex tw-items-center tw-justify-between"
                    }, [
                      _createElementVNode("p", _hoisted_28, _toDisplayString(phaseEstimateType(phase)), 1),
                      _createElementVNode("strong", _hoisted_29, _toDisplayString([
                    _unref(EscrowStatusEnum).IN_PROGRESS,
                    _unref(EscrowStatusEnum).IN_PROGRESS_POKED,
                  ].includes(phase?.escrowStatus?.id) &&
                  phase?.updatedSubTotal > 0
                    ? formattedCurrency(phase?.updatedSubTotal)
                    : formattedCurrency(phase?.subTotal)), 1)
                    ]))
                  }), 128)),
                  _createVNode(_component_v_divider, { thickness: 1 }),
                  _createElementVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _createElementVNode("strong", _hoisted_32, _toDisplayString(formattedCurrency(__props.subTotalAmount)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _hoisted_34,
                    _createElementVNode("strong", _hoisted_35, _toDisplayString(formattedCurrency(__props.vatTotal)), 1)
                  ]),
                  _createVNode(_component_v_divider, { thickness: 1 }),
                  _createElementVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _createElementVNode("strong", _hoisted_38, _toDisplayString(formattedCurrency(__props.subTotalAmount + __props.vatTotal)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createVNode(Button, {
                    variant: "accent",
                    type: "submit",
                    label: "Done",
                    onClick: onConfirm
                  }),
                  _createElementVNode("div", { class: "confirm_wrapper_issue tw-flex tw-items-center tw-gap-2 md:tw-flex-col md:tw-items-start tw-mt-8" }, [
                    _hoisted_40,
                    _createElementVNode("span", {
                      onClick: onSelectRedirectBank,
                      class: "tw-text-sm tw-tracking-[0.25px] tw-leading-[22px] tw-font-bold tw-text-[#3366FF] tw-cursor-pointer"
                    }, " Select your bank ")
                  ])
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true),
      (loading.value)
        ? (_openBlock(), _createBlock(CommonLoader, {
            key: 1,
            loading: loading.value,
            class: "loader-123"
          }, null, 8, ["loading"]))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      (!loading.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_41, [
            _createTextVNode(" By agreeing and continuing you consent to us requesting funds from your selected bank and sharing your account details with them. "),
            _hoisted_42,
            _createTextVNode(" apply. You will be redirect to your bank app for payment. ")
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})